import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection } from '@iotv/iotv-v3-types';

const typeName = 'WaterFlowReadings';

export type WaterFlowReadingsProps = {
  flowRate?: number;
  waterVolumeLastPeriod?: number;
  waterVolumeCurrentPeriod?: number;
};

export class WaterFlowReadings extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  flowRate?: number;
  waterVolumeLastPeriod?: number;
  waterVolumeCurrentPeriod?: number;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      flowRate: {
        type: 'Number',
        editable: true,
        label: 'Flow Rate',
        name: 'flowRate',
        description: 'Water flow rate through the Water Flow Meter litres/ sec and cubic metres/ sec',
      },
      waterVolumeLastPeriod: {
        type: 'Number',
        editable: true,
        label: 'Water Volume Last Period',
        name: 'waterVolumeLastPeriod',
        description: 'Water Volume through the Water Flow Meter in the current period',
      },
      waterVolumeCurrentPeriod: {
        type: 'Number',
        editable: true,
        label: 'Water Volume Current Period',
        name: 'waterVolumeCurrentPeriod',
        description: 'Water Volume through the Water Flow Meter in the last period',
      },
    };
  };
}
